const docs = {
  privacyPolicy: { ref: 'docu/PrivacyPolicy.pdf', title: 'Политика конфиденциальности' },
  offer: { ref: 'docu/Offer.pdf', title: 'Оферта' },
};

export default docs;
